/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { getBanners } from "../services/BannersService";

import { useSelector, useDispatch } from "react-redux";
import { updateBanners } from "../redux/homePageSlice";
import { Link } from "react-router-dom";
function HomePageBanner() {
  const banners = useSelector((state) => state.homepage.banners);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (banners.length > 0) {
      setLoading(false);
    } else {
      getBanners()
        .then((data) => {
          
          dispatch(updateBanners(data));
          setLoading(false);
        })
        .catch((err) => console.log(err));
    }
  }, [banners.length, dispatch]);

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  let type = "";
  return (
    !loading && (
      <div className="container">
        {banners.length > 0 && (
          <Carousel activeIndex={index} onSelect={handleSelect}>
            {banners.map((banner) => {
              return (
                <Carousel.Item key={banner.id}>
                  {banner.bannerType === 1 && (
                    <Link to={`/productDetails/${banner.entityId}`}>
                      <img
                        className="d-block w-100"
                        src={banner.pictureUrl}
                        alt="First slide"
                      />
                    </Link>
                  )}
                  {banner.bannerType === 2 && (
                    <Link to={`/products/category/${banner.entityId}`}>
                      <img
                        className="d-block w-100"
                        src={banner.pictureUrl}
                        alt="First slide"
                      />
                    </Link>
                  )}
                  {banner.bannerType === 3 && (
                    <Link to={`/products/brand/${banner.entityId}`}>
                      <img
                        className="d-block w-100"
                        src={banner.pictureUrl}
                        alt="First slide"
                      />
                    </Link>
                  )}
                </Carousel.Item>
              );
            })}
          </Carousel>
        )}
      </div>
    )
  );
}

export default HomePageBanner;
